export const LANDING_LINK = 'https://dataspike.io/';
export const LANDING_TERMS_LINK = 'https://dataspike.io/terms';
export const LANDING_PRIVACY_LINK = 'https://dataspike.io/privacy';
export const LANDING_CONTACT_US_LINK = 'https://dataspike.io/contact-us';
export const SERVICE_EMAIL = 'service@dataspike.io';
export const DOCS_API_LINK = 'https://docs.dataspike.io/#introduction';
export const DOCS_MOBILE_SDK_LINK = 'https://github.com/dataspike-io/MobileSDK-iOS';
export const DOCS_WIDGET_LINK = 'https://github.com/dataspike-io/docver-widget';
export const DOCS_BOT_LINK = 'https://t.me/DataspikeBot';
export const DOCS_WEBHOOKS_LINK = 'https://docs.dataspike.io/#webhooks';
export const DOCS_LINK = 'https://docs.dataspike.io/';
export const CDN_LINK = 'https://cdn.n37z.com';
export const DOCS_PIPECAT = 'https://docs.dataspike.io/deepfake-detection/pipecat-integration';
export const DOCS_LIVEKIT = 'https://docs.dataspike.io/deepfake-detection/livekit-integration';
